import React, { Component } from "react";
import { spring, StaggeredMotion } from "react-motion";

import { DataHandler, FastFactCard, StorageHandler } from "C4";
import { storageKeys } from "settings";

import APIHandler from "config/APIHandler";

export default class FastFacts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fastFacts: [],
    };
  }

  componentWillMount() {
    StorageHandler.load(storageKeys.user).then((user) => {
      DataHandler.matchAppId().then((appId) => {
        APIHandler.getFastFacts(appId).then((res) => {
          const startingValues = [];
          Object.keys(res).map(() => {
            const newObj = {};
            newObj.data = 0;
            newObj.pos = 20;
            return startingValues.push(newObj);
          });
        
          // Filter out items where the title contains 'HIDE_'
          const filteredFacts = res.filter((fact) => !fact.title.includes('HIDE_'));
        
          const fastFactsList = (
            <StaggeredMotion
              defaultStyles={startingValues}
              styles={(prevInterpolatedStyles) =>
                prevInterpolatedStyles.map((_, i) =>
                  i === 0
                    ? {
                        data: spring(1, { stiffness: 320, damping: 28 }),
                        pos: spring(0, { stiffness: 320, damping: 28 }),
                      }
                    : {
                        data: spring(prevInterpolatedStyles[i - 1].data, {
                          stiffness: 320,
                          damping: 28,
                        }),
                        pos: spring(prevInterpolatedStyles[i - 1].pos, {
                          stiffness: 320,
                          damping: 28 }),
                      }
                )
              }
            >
              {(styles) => (
                <React.Fragment>
                  {filteredFacts.map((fact, id) => {
                    const {
                      url,
                      title,
                      subtitle,
                      image,
                      type,
                      itemID,
                      graduated_unlock_only: graduatedUnlockOnly,
                    } = fact;
        
                    let newUrl = url;
                    let newImage = image;
                    if (url.includes(",")) {
                      newUrl = url.split(",");
                      [newImage] = newUrl;
                    }
        
                    const key = id;
                    return (
                      <div
                        key={key}
                        className="fastfactsCard__Animated"
                        style={{
                          opacity: `${styles[key].data}`,
                          transform: `translateY(${styles[key].pos}%)`,
                        }}
                      >
                        <FastFactCard
                          appId={appId}
                          image={image}
                          index={key}
                          key={key}
                          subtitle={subtitle}
                          title={title}
                          type={type}
                          url={newUrl}
                          itemID={itemID}
                          user={user}
                          graduatedUnlockOnly={graduatedUnlockOnly}
                        />
                      </div>
                    );
                  })}
                </React.Fragment>
              )}
            </StaggeredMotion>
          );
          this.setState({ fastFacts: fastFactsList });
        });
        
      });
    });
  }

  render() {
    return <div className="fastfacts__Grid">{this.state.fastFacts}</div>;
  }
}
